import BaseService from "../BaseService";

class ProductCollectionService extends BaseService {
  getListCollection = async (ids = []) => {
    var data = await this._api.post("/store/product_collection/list_by_ids", { ids });
    return data;
  };

  get = async ({ id, url_handle } = {}) => {
    var data = await this._api.get("/store/product_collection/get", {
      params: { id, url_handle },
    });
    return data;
  };

  products = async ({ id, url_handle, info } = {}) => {
    var data = await this._api.post("/store/product_collection/products", {
      id,
      url_handle,
      info,
    });
    return data;
  };
}

export default ProductCollectionService;
